<template lang="pug">
v-card(v-if="sales", flat)
  simple-table
    thead
      tr
        th Gift Card Sold
        th.text-right {{ sales.amount | currency }}
    tbody
      tr(v-for="(item, index) in sales.items", :key="index")
        td {{ item.type }} ({{ item.count }})
        td.text-right {{ item.amount | currency }}
</template>

<script>
export default {
  props: ["sales"],
};
</script>
